import GameFrameButtons from "../frame-buttons";
import GameCurrencyAndMode from "../game-currency-and-mode";
import '../index.css'
import Loading from "../../../components/loading";
import {useEffect, useRef, useState} from "react";
import PlayGameWebFrameError from "./frame-web-error";
import {useTranslation} from "react-i18next";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import parse from 'html-react-parser';
import BeforeLoading from "../../../components/before-loading";
import {useSelector} from "react-redux";

const PlayGameWebFrame = (props) => {
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const {
        json,
        showConf,
        handleSetGameType,
        currencies,
        game,

        gameType,
        favorited,
        setGameType,
        error,
        setFavorited
    } = props

    const [loading, setLoading] = useState(true)
    const iframeRef = useRef(null)

    const {t} = useTranslation()


    useEffect(() => {
        try {
            setLoading(true)

            if (json.gameHtml) {
                document.getElementById('game-parent').innerHTML = json.gameHtml
            }
            if (json.gameScript) {
                const replaced = json?.gameScript
                // const staticOrigin = 'https://betyoner.com'
                //
                // let replaced = json?.gameScript?.replace(
                //     /var\s+ref\s*=\s*[^;]+;/,
                //     `var ref = "${staticOrigin}";`
                // );


                //             replaced = replaced.replace(
                //                 /request\.addEventListener\(['"]loadend['"],\s*function\s*\(\)\s*{[\s\S]*?}\s*\);/,
                //                 `request.addEventListener('loadend', function() {
                //     if (request.status !== 200) {
                //         console.log('check result: ERROR', request.status);
                //         document.getElementById('egamings_container').outerHTML = '';
                //         alert('Restricted');
                //     } else {
                //         console.log('check result: OK');
                //         console.log('request.responseText:', request.responseText);
                //         var resp = JSON.parse(request.responseText);
                //         console.log('Game URL:', resp.data);
                //     }
                // });`
                //             );
                console.log('json?.gameScript = replaced')
                console.log(replaced)

                // const sanitizedScript = json?.gameScript?.replace(/alert\s*\(.*?\);?/g, '');
                const sanitizedScript = replaced
                const existing = document.getElementById('game-script')
                if (existing)
                    existing?.remove()

                const script = document.createElement('script');
                script.id = "game-script"
                script.type = 'text/javascript';
                script.innerHTML = sanitizedScript;

                if (game?.slug?.includes('atmosfera')) {
                    script.onload = () => {
                        // Append the script to the frame-wrapper (but only if it exists in the DOM)
                        if (iframeRef?.current) {
                            document.head.appendChild(script);
                        }
                    }
                } else {
                    document.head.appendChild(script);
                    setLoading(false)
                }


                script.onload = e => console.log('SCRIPT LOADED  - ', e)
                script.onerror = (err) => {
                    console.error('Script load error:', err);
                };
            } else {
                setLoading(false)
            }


        } catch (e) {
            console.error(e)
        }


    }, [json.gameScript, json.gameHtml, iframeRef?.current, game]);
    const handleFullScreen = () => iframeRef?.current?.requestFullscreen()
    const handleFullScreenExit = () => iframeRef?.current?.exitFullscreen()

    const isFullScreen = () => !!(iframeRef?.current.fullScreen || iframeRef?.current.webkitIsFullScreen || iframeRef?.current.mozFullScreen || iframeRef?.current.msFullscreenElement || iframeRef?.current.fullscreenElement);

    const handleAction = type => {
        switch (type) {
            case 'fullscreen':
                return isFullScreen() ? handleFullScreenExit() : handleFullScreen()

            case 'favorite':
                return handleFavoriteGame()

            case 'stats':
                return console.log(type)
            default:
                return null;

        }
    }

    const handleFavoriteGame = () => {

        if (!authenticated)
            return store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('register'))

        associateServices.favoriteGame({
            game_id: game?.id
        }).then(response => {
            setFavorited(!favorited)
            return toast(<InformationToast
                icon={response?.status === 200 ? 'ti-check' : 'ti-error-404'}
                title={response?.status === 200 ? game?.name : '...'}
                message={t(`api-notifications.${response?.data || response?.errors}`)}
            />)
        })
    }

    useEffect(() => {
        if (document.querySelector('.frame')) {
            var frameGame = document.querySelector('.frame');
            var frameTheatreBtn = document.querySelector('.frame-theatre');

            function toggleTheatre() {
                frameGame.classList?.toggle('frame--theatre');
            }

            frameTheatreBtn.addEventListener('click', toggleTheatre);
        }

    }, [])

    // useEffect(() => {
    //     if (gameUiURL?.includes('gameScript')) {
    //         const response = JSON.parse(gameUiURL)
    //         console.log('response = ', response)
    //         const container = document.getElementById('game-container')
    //         container.innerHTML = response?.gameHtml
    //         eval(response.gameScript)
    //     }
    // }, [gameUiURL])

    // console.log('showConf = ',showConf)
    return (
        <div className="game-container-wrap frame">
            <div ref={iframeRef} className={`frame__cover ${showConf ? '' : 'hide'}`} id="frame-wrapper"
                // dangerouslySetInnerHTML={{__html: json.gameHtml}}>
            >
                {
                    !loading && !error &&
                    <div style={{
                        position: 'absolute',
                        background: 'transparent'
                    }}>
                        <BeforeLoading transparent={true}/>
                    </div>
                }

                <div id="game-parent"/>

                {
                    error && <PlayGameWebFrameError error={t(`api-notifications.${error}`)}/>
                }


                {

                    loading ?
                        <div className="frame__nav">
                            <Loading/>
                        </div>
                        : showConf &&
                        <GameCurrencyAndMode
                            onClick={handleSetGameType}
                            currencies={currencies}
                            game={game}
                        />
                }
            </div>


            <GameFrameButtons
                onClick={handleAction}
                gameType={gameType}
                game={game}
                favorited={favorited}
                currencies={currencies}
                setGameType={setGameType}
            />
        </div>
    )


}

export default PlayGameWebFrame
